module.exports = __webpack_public_path__ + "img/camera-reels-fill.f1abec79.svg";